// src/components/Root/sections.js
import {
	Users,
	Dog,
	Tag,
	Phone,
	Calendar,
	MapPin,
	Stethoscope,
} from "lucide-react";

export const SECTIONS = {
	usuarios: {
		title: "Usuarios",
		icon: Users,
		endpoint: "usuarios",
		singular: "usuario",
		fields: [
			{ name: "nombre", label: "Nombre", type: "text", required: true },
			{
				name: "apellido",
				label: "Apellido",
				type: "text",
				required: true,
			},
			{ name: "email", label: "Email", type: "email", required: true },
			{
				name: "password",
				label: "Contraseña",
				type: "password",
				required: true,
			},
			{
				name: "fecha_nacimiento",
				label: "Fecha nacimiento",
				type: "date",
			},
			{
				name: "recibir_emails",
				label: "Recibir emails",
				type: "checkbox",
			},
			{ name: "root", label: "Usuario root", type: "checkbox" },
		],
		columns: ["foto", "nombre", "apellido", "email", "fecha_nacimiento"],
	},
	mascotas: {
		title: "Mascotas",
		icon: Dog,
		endpoint: "mascotas",
		singular: "mascota",
		fields: [
			{ name: "nombre", label: "Nombre", type: "text", required: true },
			{
				name: "fecha_nacimiento",
				label: "Fecha nacimiento",
				type: "date",
			},
			{
				name: "sexo",
				label: "Sexo",
				type: "select",
				required: true,
				options: [
					{ value: 0, label: "Macho" },
					{ value: 1, label: "Hembra" },
				],
			},
			{ name: "descripcion", label: "Descripción", type: "textarea" },
			{ name: "direccion", label: "Dirección", type: "textarea" },
			{
				name: "id_usuario",
				label: "Usuario",
				type: "fk_select",
				required: true,
				fkEndpoint: "usuarios",
				fkValue: "id",
				fkLabel: (u) =>
					`${u.nombre || ""} ${u.apellido || ""} — ${u.email || ""}`,
			},
			{
				name: "codigo_unico",
				label: "Código QR/NFC",
				type: "text",
				required: true,
				placeholder: "ABCD1234",
				readonlyOnEdit: true,
			},
			{
				name: "mensajeRescate",
				label: "Mensaje rescate",
				type: "textarea",
			},
			{ name: "persona1", label: "Persona 1", type: "text" },
			{ name: "persona1tel", label: "Teléfono persona 1", type: "tel" },
			{ name: "persona1ig", label: "Instagram persona 1", type: "text" },
			{ name: "persona2", label: "Persona 2", type: "text" },
			{ name: "persona2tel", label: "Teléfono persona 2", type: "tel" },
			{ name: "persona2ig", label: "Instagram persona 2", type: "text" },
		],
		columns: [
			"foto",
			"nombre",
			"id_usuario",
			"codigo_id",
			"sexo",
			"fecha_nacimiento",
		],
		fkColumns: {
			id_usuario: {
				endpoint: "usuarios",
				label: (u) => `${u.nombre || ""} ${u.apellido || ""}`,
			},
			codigo_id: { endpoint: "codigos", label: (c) => c.codigo_unico },
		},
	},
	codigos: {
		title: "Códigos",
		icon: Tag,
		endpoint: "codigos",
		singular: "codigo",
		fields: [
			{
				name: "codigo_unico",
				label: "Código único",
				type: "text",
				required: true,
				placeholder: "ABCD1234",
				readonlyOnEdit: true,
			},
		],
		columns: ["codigo_unico", "estado", "accion"],
	},
	contactos: {
		title: "Contactos",
		icon: Phone,
		endpoint: "contactos",
		singular: "contacto",
		fields: [
			{
				name: "id_mascota",
				label: "Mascota",
				type: "fk_select",
				required: true,
				fkEndpoint: "mascotas",
				fkValue: "id",
				fkLabel: (m) => `${m.nombre || "Mascota"} (ID ${m.id})`,
			},
			{
				name: "tipo",
				label: "Tipo",
				type: "select",
				required: true,
				options: [
					{ value: "veterinario", label: "Veterinario" },
					{ value: "paseador", label: "Paseador" },
					{ value: "peluqueria", label: "Peluquería" },
					{ value: "petshop", label: "Petshop" },
					{ value: "guarderia", label: "Guardería" },
					{ value: "otro", label: "Otro" },
				],
			},
			{
				name: "categoria_personalizada",
				label: "Categoría personalizada",
				type: "text",
			},
			{ name: "nombre", label: "Nombre", type: "text", required: true },
			{ name: "apellido", label: "Apellido", type: "text" },
			{ name: "celular", label: "Celular", type: "tel" },
			{ name: "telefono_fijo", label: "Teléfono fijo", type: "tel" },
			{ name: "email", label: "Email", type: "email" },
			{ name: "direccion", label: "Dirección", type: "text" },
			{ name: "horarios", label: "Horarios", type: "text" },
			{ name: "dias_atencion", label: "Días atención", type: "text" },
			{ name: "notas", label: "Notas", type: "textarea" },
			{ name: "favorito", label: "Favorito", type: "checkbox" },
		],
		columns: ["id", "id_mascota", "nombre", "tipo", "celular"],
		fkColumns: {
			id_mascota: { endpoint: "mascotas", label: (m) => m.nombre },
		},
	},
	historial: {
		title: "Historial",
		icon: Calendar,
		endpoint: "historial",
		singular: "historial",
		fields: [
			{
				name: "id_mascota",
				label: "Mascota",
				type: "fk_select",
				required: true,
				fkEndpoint: "mascotas",
				fkValue: "id",
				fkLabel: (m) => `${m.nombre || "Mascota"} (ID ${m.id})`,
			},
			{
				name: "tipo_evento",
				label: "Tipo",
				type: "select",
				required: true,
				options: [
					{ value: "cita", label: "Cita" },
					{ value: "vacuna", label: "Vacuna" },
					{ value: "bitacora", label: "Bitácora" },
				],
			},
			{ name: "titulo", label: "Título", type: "text", required: true },
			{
				name: "fecha_evento",
				label: "Fecha evento",
				type: "date",
				required: true,
			},
			{ name: "proxima_fecha", label: "Próxima fecha", type: "date" },
			{ name: "nota", label: "Nota", type: "textarea" },
			{ name: "laboratorio", label: "Laboratorio", type: "text" },
			{ name: "lote", label: "Lote", type: "text" },
			{ name: "completada", label: "Completada", type: "checkbox" },
			{ name: "recordatorio", label: "Recordatorio", type: "checkbox" },
		],
		columns: ["id", "id_mascota", "titulo", "tipo_evento", "fecha_evento"],
		fkColumns: {
			id_mascota: { endpoint: "mascotas", label: (m) => m.nombre },
		},
	},
	productos: {
		title: "Productos",
		icon: Tag,
		endpoint: "productos",
		singular: "producto",
		fields: [
			{ name: "titulo", label: "Título", type: "text", required: true },
			{ name: "descripcion", label: "Descripción", type: "textarea" },
			{
				name: "precio",
				label: "Precio",
				type: "number",
				required: true,
				step: "0.01",
				min: "0",
			},
			{ name: "oferta", label: "En oferta", type: "checkbox" },
			{ name: "activo", label: "Activo", type: "checkbox" },
		],
		columns: ["foto", "titulo", "precio", "oferta", "activo"],
	},
	socios: {
		title: "Socios SmartPet",
		icon: Stethoscope,
		endpoint: "socios",
		singular: "socio",
		fields: [
			{ name: "nombre", label: "Nombre", type: "text", required: true },
			{ name: "apellido", label: "Apellido", type: "text" },
			{
				name: "nombre_local",
				label: "Nombre del local",
				type: "text",
				required: true,
			},
			{
				name: "tipo_servicio",
				label: "Tipo de servicio",
				type: "select",
				required: true,
				options: [
					{ value: "veterinaria", label: "Veterinaria" },
					{ value: "paseador", label: "Paseador" },
					{ value: "petshop", label: "Petshop" },
					{ value: "guarderia", label: "Guardería" },
					{ value: "peluqueria", label: "Peluquería" },
					{ value: "otros", label: "Otros" },
				],
			},
			{
				name: "whatsapp",
				label: "WhatsApp",
				type: "tel",
				required: true,
			},
			{ name: "direccion", label: "Dirección", type: "text" },
			{ name: "descripcion", label: "Descripción", type: "textarea" },
			{ name: "dias_atencion", label: "Días de atención", type: "text" },
			{ name: "horarios_atencion", label: "Horarios", type: "text" },
			{
				name: "servicio_24h",
				label: "Servicio 24 horas",
				type: "checkbox",
			},
			{ name: "emergencias", label: "Emergencias", type: "checkbox" },
		],
		columns: [
			"foto",
			"nombre_local",
			"tipo_servicio",
			"whatsapp",
			"servicio_24h",
			"emergencias",
		],
	},
	ubicaciones: {
		title: "Ubicaciones",
		icon: MapPin,
		endpoint: "ubicaciones",
		singular: "ubicacion",
		fields: [
			{
				name: "id_mascota",
				label: "Mascota",
				type: "fk_select",
				required: true,
				fkEndpoint: "mascotas",
				fkValue: "id",
				fkLabel: (m) => `${m.nombre || "Mascota"} (ID ${m.id})`,
			},
			{
				name: "lugar",
				label: "Dirección (calle y ciudad)",
				type: "text",
				required: true,
				placeholder: "Av. Siempreviva 742, Springfield",
			},
			{
				name: "ubicacion",
				label: "Coordenadas (para el mapa)",
				type: "text",
				placeholder: "-30.766238,-57.984069",
			},
		],
		// La tabla muestra "lugar" en lugar de coordenadas
		columns: ["id", "id_mascota", "lugar", "fecha_hora"],
		fkColumns: {
			id_mascota: { endpoint: "mascotas", label: (m) => m.nombre },
		},
	},
};
